import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_educationalMaterials: {
         form: {
            actionInput: {
               placeholder: 'Wyszukaj po nazwie lub autorze...',
            },
            table: {
               headers: {
                  authors: 'Autor',
                  creationDate: 'Data dodania',
                  name: 'Nazwa',
               },
               placeholder: 'Brak pasujących materiałów',
            },
         },
         openError: 'Nie udało się otworzyć materiału. Spróbuj ponownie później.',
         removedMaterialFromMaterialShippingList: 'Usunięto materiał z listy do wysyłki.',
         share: {
            cancel: 'Anuluj',
            educationalMaterialsSentToPatient: 'Wysłano materiały do pacjenta.',
            email: 'Adres e-mail',
            fillPatientEmail: 'Uzupełnij adres e-mail pacjenta...',
            send: 'Wyślij',
            sendingEducationalMaterialsToPatient: 'Wysyłanie materiałów',
            shareEducationalMaterialsWithPatient: 'Udostępnij materiały pacjentowi',
            table: {
               name: 'Nazwa',
            },
         },
         shareSelected: 'Udostępnij wybrane ({{ selectedCount }})',
         title: 'Baza wiedzy',
      },
   },
};

export const educationalMaterialsTranslationKeys = createScopedTranslationKeys(
   translations.pl,
   'visit_educationalMaterials'
);
